export default __webpack_public_path__ + "static/media/3.2e3b773e.jpg";